/* eslint-disable */ import { assertNumber, attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const topWithLengthAndWidthComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'length', true).withAlias('TopWithLengthAndWidth').attach(memoEval((self)=>[
            self.length,
            self.$lengthOptions
        ], (length, $lengthOptions)=>({
            value: length,
            options: $lengthOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            length: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'width', true).withAlias('TopWithLengthAndWidth').attach(memoEval((self)=>[
            self.width,
            self.$widthOptions
        ], (width, $widthOptions)=>({
            value: width,
            options: $widthOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            width: state.value
        };
    })
];

//# sourceMappingURL=top-with-length-and-width.js.map